var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2832 2.7832V1.7168H3.875V2.7832H9.2832ZM7.125 7.125V6.0332H3.875V7.125H7.125ZM9.2832 4.9668V3.875H3.875V4.9668H9.2832ZM9.8418 0.0917969C10.1296 0.0917969 10.375 0.201823 10.5781 0.421875C10.7982 0.625 10.9082 0.870443 10.9082 1.1582V7.6582C10.9082 7.94596 10.7982 8.19987 10.5781 8.41992C10.375 8.63997 10.1296 8.75 9.8418 8.75H3.3418C3.05404 8.75 2.80013 8.63997 2.58008 8.41992C2.36003 8.19987 2.25 7.94596 2.25 7.6582V1.1582C2.25 0.870443 2.36003 0.625 2.58008 0.421875C2.80013 0.201823 3.05404 0.0917969 3.3418 0.0917969H9.8418ZM1.1582 2.25V9.8418H8.75V10.9082H1.1582C0.870443 10.9082 0.616536 10.8066 0.396484 10.6035C0.193359 10.3835 0.0917969 10.1296 0.0917969 9.8418V2.25H1.1582Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryBooks);
export default __webpack_public_path__ + "static/media/library_books.69253b5b868787be694dd08a4c7cdf4f.svg";
export { ForwardRef as ReactComponent };